import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/* Poster wideo: pierwsza klatka klipu (webp ~5 KB), widoczna od razu i jako fallback. */
import heroPoster from '../../../../assets/images/auth/auth-hero-poster.webp';
import { type AuthBrand, AuthTopBar } from '../AuthTopBar';
import { AuthHeroVideo } from './AuthHeroVideo';
import { AuthLanguageSwitch } from './AuthLanguageSwitch';
import {
  AuthFooter,
  AuthFooterEnd,
  AuthFooterInner,
  AuthFooterLinks,
  AuthPage,
  FormCard,
  Hero,
  HeroGrid,
  Intro,
  PhotoPane,
} from './AuthLayout.styled';
import { TypingIntro } from './TypingIntro';

interface AuthLayoutProps {
  children: ReactNode;
  brand?: AuthBrand;
}

/* Wspólna rama ekranów auth: pasek górny, pisane powitanie po lewej, wideo po prawej i karta z formularzem.
   Ekrany różnią się tylko zawartością karty (children). */
export const AuthLayout: FC<AuthLayoutProps> = ({ children, brand }) => {
  const { t } = useTranslation();

  return (
    <AuthPage>
      <AuthTopBar brand={brand} />

      <Hero>
        <PhotoPane>
          <AuthHeroVideo poster={heroPoster} webm="/video/auth-hero.webm" mp4="/video/auth-hero.mp4" />
        </PhotoPane>

        <HeroGrid>
          <Intro aria-labelledby="auth-intro-title">
            <TypingIntro />
          </Intro>

          <FormCard>{children}</FormCard>
        </HeroGrid>
      </Hero>

      <AuthFooter>
        <AuthFooterInner>
          <span>{t('auth.footer.copyright', { year: new Date().getFullYear() })}</span>
          <AuthFooterEnd>
            <AuthFooterLinks aria-label={String(t('auth.footer.terms'))}>
              <a href="/pl/regulamin" target="_blank" rel="noopener noreferrer">{t('auth.footer.terms')}</a>
              <a href="/privacy" target="_blank" rel="noopener noreferrer">{t('auth.footer.privacy')}</a>
              <a href="/pl/cookies" target="_blank" rel="noopener noreferrer">{t('auth.footer.cookies')}</a>
            </AuthFooterLinks>
            <AuthLanguageSwitch />
          </AuthFooterEnd>
        </AuthFooterInner>
      </AuthFooter>
    </AuthPage>
  );
};
